import { http } from 'services'
// initial state
const state = () => ({
  all: [],
  active: {},
  errors: null
})

// getters
const getters = {
}

// actions
const actions = {
  ['vendors.getAll'] ({ commit }, params) {
    if (!params._q) params._q = null

    commit('CLEAR_ERRORS')

    return (http.get('vendors', {
      params
    })).then ((res) => {
      commit('GET_ALL_VENDORS', res);
    })
    .catch ((res) => {
      commit('VENDORS_ERROR', res);
    })
  },
  ['vendors.newVendor'] ({ commit }, data) {
    commit('CLEAR_ERRORS')

    return (http.post('vendors', data))
    .then ((res) => {
    })
    .catch ((res) => {
      commit('VENDORS_ERROR', res);
    })
  },
  ['vendors.editVendor'] ({ commit }, {id, data}) {
    commit('CLEAR_ERRORS')
    return (http.put('vendors/' + id , data))
    .then ((res) => {
      commit('EDIT_VENDOR', res);
    })
    .catch ((res) => {
      commit('VENDORS_ERROR', res);
    })
  },
  ['vendors.removeVendor'] ({ commit }, id) {
    commit('CLEAR_ERRORS')

    return (http.delete('vendors/' + id))
    .then ((res) => {
      commit('REMOVE_VENDOR', id);
    })
    .catch ((res) => {
      commit('VENDORS_ERROR', res);
    })
  },
  ['vendors.getVendor'] ({ dispatch, commit, state }, id) {
    commit('CLEAR_ERRORS')
    return dispatch('roles.getAll', {_all: true}).then(() => {
      return (http.get('vendors/' + id))
      .then ((res) => {
        commit('GET_VENDOR', res);
      })
      .catch ((res) => {
        commit('VENDORS_ERROR', res);
      })
    })
  },
}

// mutations
const mutations = {
  GET_ALL_VENDORS (state, res) {

    state.all = res.data;
  },

  GET_VENDOR (state, res) {
    state.active = res.data
  },

  REMOVE_VENDOR (state, id) {
    state.all.data = _.filter(state.all.data, (item) => item.id != id);
  },

  EDIT_VENDOR (state, res) {
    state.active = res.data
  },

  //ERRORS
  VENDORS_ERROR (state, err) {
    try {
      state.errors = err.response.data;
    } catch (e) {
      state.errors = err;
    }
  },

  CLEAR_ERRORS (state) {
    state.errors = null
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
